import http from '@/config/api';
import router from '@/router';

export default {
  async registCard(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/card`, payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async deleteCard({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    const response = await http.post(`/event/${directory}/card/delete`, {}).then(
      (res) => res.data,
      () => null
    );
    if(response && response.message == true) {
      commit('SET_DELETE_CARD_STATUS', true);
    }
  },
  async getCardInfo({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    http.get(`event/${directory}/card`).then((res) => {
      commit('SET_CARD_INFO', res.data);
    });
  },
  async updateInfo(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/user`, payload).then(
      (res) => res,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  // CONFIRM INFO STEP 1
  async confirmRegistInfo({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/user?mode=${payload.mode}`, payload).then(
      (res) => {
        commit('SET_REGIST_INFO', payload);
        return res.data;
      },
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  // SEND CODE STEP 2
  async sendVerify(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/verify`, payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async sendCodeVerify(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/verify/code`, payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  // REGIST STEP 3 (FINAL)
  async registMember(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/user`, payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async updatePasscode(_, payload) {
    const response = await http.post('/passcode/update', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async registPasscode(_, payload) {
    const response = await http.post('/passcode/create', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async changePassword(_, payload) {
    const response = await http.post('/user/password', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async deleteUser(_, payload) {
    const response = await http.delete('/user', { data: payload }).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async resetMail(_, payload) {
    const response = await http.post('/user/email', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async setNewMail(_, decodedToken) {
    const response = await http
      .post(`/user/email/${decodedToken[2] || 'NULL'}`, {
        verify: {
          string: decodedToken[1],
          code: decodedToken[0],
          ...(decodedToken[4] ? { id: decodedToken[4] } : {}),
        },
      })
      .then(
        (res) => res.data,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
  async getCPMDetail({ commit }, payload) {
    return await http
      .get(`event/cpm/${payload.cpmUserId}`)
      .then((response) => {
        commit('SET_CPM_DETAIL', response?.data);
        return response?.data;
      });
  },
  async getSwitchCpmDetail({ commit }, params) {
    return await http
      .get(`event/cpm/${params.cpmUserId}`, {
        params: {
          forSwitchCpm: 0,
        },
      })
      .then((response) => {
        commit('SET_CPM_DETAIL', response?.data);
        return response?.data;
      });
  },
  async switchCpmKeyword(_, payload) {
    const response = await http.post('/event/verify/keyword', payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  async confirmSwitchCpm(_, payload) {
    const response = await http.post(`/event/transfer_balance_cpm/${payload.cpmUserId}`, payload).then(
      (res) => res.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return response;
  },
  resetRegistInfo({ commit }) {
    sessionStorage.removeItem('registInfo');
    commit('RESET_REGIST_INFO');
  },
  resetCpmDetail({ commit }) {
    commit('RESET_CPM_DETAIL');
  },
  setFormData({ commit }, data) {
    commit('SET_FORM_DATA', data);
  },
  resetFormData({ commit }) {
    commit('RESET_FORM_DATA');
  }
};
